<div class="video-dialog-container">
  <div class="header-container">
    <div>Welcome to Construction Pathways</div>
    <div class="cros-icon" (click)="close()">
      <img src="assets/images/cross-icon.svg" class="cross-icon" />
    </div>
  </div>

  <div class="video-content">
    <div class="video-player-container">
      <video
        *ngIf="safeVideoUrl"
        [src]="safeVideoUrl"
        controls
        controlsList="nodownload"
        preload="auto"
        autoplay
        muted
      ></video>
      <p *ngIf="!safeVideoUrl" style="color:#fff; text-align:center; padding:20px;">Loading video...</p>
    </div>
  </div>
</div>
